export const environment = {
  production: false,

  // Producción

  name: 'produccion',
  urlAddressHome: 'https://www.copilotocolombia.com:45113/api/crm/',
  urlAddressCommon: 'https://www.copilotocolombia.com:45101/api/comun/',
  urlAddressValidations: 'https://www.copilotocolombia.com:45104/api/validaciones/',
  urlAddressBilletera: 'https://www.copilotocolombia.com:45117/api/billetera/',
  urlAddressAuthentication: 'https://www.copilotocolombia.com:45117/api/billetera/comercios/',
  urlAddressSecurity: 'https://www.copilotocolombia.com:45120/api/totp/'
};
